import React from 'react';
import { useBrandingColors } from '../../hooks/useBrandingColors';
import HHAuthContent from './HHAuthContent';

interface HHAuthCardProps {
  onBackToSearch: () => void;
}

const HHAuthCard: React.FC<HHAuthCardProps> = ({
  onBackToSearch
}) => {
  const colors = useBrandingColors();
  return (
    <div className="bg-[#f5f6f1] rounded-xl p-[24px] min-h-[calc(100vh-280px)] w-full">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-semibold text-gray-900">Авторизация HH.ru</h2>
        <button
          onClick={onBackToSearch}
          className="transition-colors text-[15px] font-medium"
          style={{ color: colors.primary }}
          onMouseEnter={(e) => (e.currentTarget.style.color = colors.primaryHover)}
          onMouseLeave={(e) => (e.currentTarget.style.color = colors.primary)}
        >
          ← Назад к поиску
        </button>
      </div>
      
      <div className="flex-1 w-full">
        <HHAuthContent />
      </div>
      

    </div>
  );
};

export default HHAuthCard;
